import { Direction, TransactionAlertsLevels } from '@/api';
import { RiskKeys } from '@/config';

import {
  transactionAlertsTableGroups,
  emptyLevels,
} from './TransactionAlertsTable.constants';

export const getGroupLevels = (
  group: (typeof transactionAlertsTableGroups)[number],
  data: TransactionAlertsLevels,
) => {
  return Object.entries(data)
    .filter(([category]) => group.signals.includes(category as RiskKeys))
    .flatMap(([category, directions]) =>
      Object.entries(directions || {}).map(([dir, interTypes]) => {
        const directionKey = dir as Direction;
        const direct = interTypes?.direct ?? emptyLevels;
        const indirect = interTypes?.indirect ?? emptyLevels;

        return {
          category: category as RiskKeys,
          direction: directionKey,
          low: {
            direct: {
              value: direct.low,
            },
            indirect: {
              value: indirect.low,
            },
          },
          medium: {
            direct: {
              value: direct.medium,
            },
            indirect: {
              value: indirect.medium,
            },
          },
          high: {
            direct: {
              value: direct.high,
            },
            indirect: {
              value: indirect.high,
            },
          },
          severe: {
            direct: {
              value: direct.severe,
            },
            indirect: {
              value: indirect.severe,
            },
          },
        };
      }),
    );
};

export const getSortedCategoryOptions = (supportedRiskKeys: string[]) => {
  const sorted: { label: string; value: string }[] = [];

  transactionAlertsTableGroups.forEach((group) => {
    group.signals.forEach((key) => {
      const foundGroup = transactionAlertsTableGroups.find((g) =>
        g.signals.includes(key),
      );

      sorted.push({
        label: foundGroup?.title || key,
        value: key,
      });
    });
  });

  return sorted.filter((opt) => supportedRiskKeys.includes(opt.value));
};
